import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Title from "../../extras/Title";
import { getOrder, updateOrderStatus } from "../../../redux/slice/orderSlice";
import Table from "../../extras/Table";
import Pagination from "../../extras/Pagination";
import Button from "../../extras/Button";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Edit } from "../../../assets/icon/edit.svg";
import { closeDialog, openDialog } from "../../../redux/slice/dialogueSlice";
import Input, { ExInput } from "../../extras/Input";
import EditOrder from "./EditOrder";
import { ReactComponent as Delievered } from "../../../assets/icon/deliever.svg";
import { ReactComponent as Cancel } from "../../../assets/icon/cancel.svg";
import {
    IconBasketCheck,
    IconCircleDashedX,
    IconEdit,
} from "@tabler/icons-react";
import LazyImage from "../../extras/ImageFallback";

const Order = () => {
    const [type, setType] = useState("All");
    const { ordersData, total } = useSelector((state) => state.ordersData);
    const orderType = [
        { name: "Pending", value: "Pending" },
        { name: "Confirmed", value: "Confirmed" },
        { name: "Out Of Delivery", value: "Out Of Delivery" },
        { name: "Delivered ", value: "Delivered" },
        { name: "Cancelled ", value: "Cancelled" },
    ];
    const { setting } = useSelector((state) => state.setting);

    const [data, setData] = useState([]);
    const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
    const dispatch = useDispatch();
    useEffect(() => {
        setData(ordersData);
    }, [ordersData]);
    console.log("ordersData", ordersData);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event, 10));
        setPage(0);
    };
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    useEffect(() => {
        const payload = {
            start: page,
            limit: rowsPerPage,
            status: type,
        };
        dispatch(getOrder(payload));
    }, [type, page]);
    const navigate = useNavigate();
    const handleOrderView = (id) => {
        navigate(`/admin/order/orderDetails`, {
            state: id,
        });
    };

    const groupedOrders = ordersData?.reduce((acc, order) => {
        console.log("1234", ordersData);
        const existingOrderIndex = acc.findIndex(
            (item) => item.orderId === order.orderId
        );
        const orderData = {
            orderId: order?.orderId,

            firstName: order?.userId?.fname,
            lastName: order?.userId?.lname,
            finalTotal: order?.finalTotal,

            items: order?.items?.map((item) => ({
                mainImage: item?.product?.mainImage,
                productName: item?.product?.productName,
                productQuantity: item?.productQuantity,
                purchasedTimeProductPrice: item?.purchasedTimeProductPrice,
                purchasedTimeShippingCharges: item?.purchasedTimeShippingCharges,
                commissionPerProductQuantity: item?.commissionPerProductQuantity,
                status: item?.status,
                itemId: item?._id,
                userId: order?.userId?._id,
                orderMainId: order?._id,
            })),
        };
        if (existingOrderIndex >= 0) {
            // If order already exists, push the new items
            acc[existingOrderIndex].items.push(...orderData.items);
        } else {
            // If new order, push to the accumulator
            acc.push(orderData);
        }
        return acc;
    }, []);

    // Flattening for pagination
    console.log("Acccccccc", groupedOrders);
    const flattenedOrders = groupedOrders?.flatMap((order, orderIndex) => {
        console.log("orderrr", order);
        // Maintain a counter for the serial number
        let srNo = orderIndex + 1;
        return order?.items?.map((item, index) => ({
            isGrouped: index === 0, // Mark the first item to show order ID and user info
            srNo: index === 0 ? srNo : null, // Only assign serial number to the first item in the group
            orderId: order?.orderId,
            firstName: order?.firstName,
            lastName: order?.lastName,
            finalTotal: order?.finalTotal,
            ...item,
        }));
    });

    const orderTable = [
        {
            Header: "SR NO",
            Cell: ({ row, index }) => {
                if (row?.isGrouped && row?.srNo) {
                    return <span>{page * rowsPerPage + parseInt(index) + 1}</span>; // Use the srNo generated above
                }
                return null;
            },
        },
        {
            Header: "Items",
            Cell: ({ row }) => (
                <>
                    <div className="d-flex justify-content-start gap-3">
                        {/* <div>
              <img src={row?.mainImage} />
            </div> */}
                        <div className="userProfile">
                            <LazyImage
                                src={row && row.mainImage}
                                alt="images"
                                className="cursor-pointer"
                                style={{ height: "50px", width: "50px", overflow: "hidden" }}
                                height={`100%`}
                            />
                        </div>

                        <div className="text-start pl-2">
                            <div>{row?.productName}</div>
                            <div>
                                Quantity : <span>{row?.productQuantity}</span>
                            </div>
                            <div>Price : ${row?.purchasedTimeProductPrice}</div>
                        </div>
                    </div>
                </>
            ),
        },
        {
            Header: "User Info",
            Cell: ({ row }) =>
                row?.isGrouped ? <div>{row?.firstName || "-"}</div> : null,
        },
        {
            Header: "Order ID",
            Cell: ({ row }) =>
                row?.isGrouped ? (
                    <span
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={() => handleOrderView(row?.orderMainId)}
                    >
                        {row?.orderId}
                    </span>
                ) : null,
        },

        {
            Header: `Price (${setting?.currencySymbol || "$"})`,
            Cell: ({ row }) => (
                <>
                    <div>
                        $
                        {row?.purchasedTimeProductPrice * row?.productQuantity
                            ? row?.purchasedTimeProductPrice * row?.productQuantity
                            : "-"}
                    </div>
                </>
            ),
        },
        {
            Header: "Shipping Charge",
            Cell: ({ row }) => (
                <>
                    <div>
                        $
                        {row?.purchasedTimeShippingCharges
                            ? row?.purchasedTimeShippingCharges
                            : "-"}
                    </div>
                </>
            ),
        },
        {
            Header: "Admin Commission",
            Cell: ({ row }) => (
                <>
                    <div>
                        {row?.commissionPerProductQuantity === 0
                            ? 0
                            : row?.commissionPerProductQuantity}
                    </div>
                </>
            ),
        },
        {
            Header: "Status",
            Cell: ({ row }) => {
                return (
                    <div className="mb-2">
                        {" "}
                        {/* Add margin for spacing */}
                        {row?.status === "Pending" ? (
                            <div className="badge badge-success p-2">Pending</div>
                        ) : row?.status === "Confirmed" ? (
                            <div className=" badge-success badge p-2 ">Confirmed</div>
                        ) : row?.status === "Out Of Delivery" ? (
                            <div className=" badge-warning  badge p-2">Out Of Delivery</div>
                        ) : row?.status === "Delivered" ? (
                            <div className=" badge-info badge p-2 ">Delivered</div>
                        ) : row?.status === "Cancelled" ? (
                            <div className=" badge-danger badge p-2">Cancelled</div>
                        ) : (
                            <div className=" badge-danger badge p-2">Status Unknown</div>
                        )}
                    </div>
                );
            },
        },
        {
            Header: "Action", // Show the Action header
            Cell: ({ row }) => {
                const { status } = row; // Extract status from the row
                return (
                    <div className="action-button">
                        {/* {status === "Cancelled" ? (<button className="btn btn-sm" >
                            <IconCircleDashedX className="text-secondary" />
                        </button>
                        ) : status === "Delivered" ? (<button className="btn btn-sm" >
                            <IconBasketCheck className="text-secondary" />
                        </button>
                        ) : ( */}
                            <button
                                className={`btn btn-sm ${['Cancelled' , "Delivered"].includes(status) ? "disabled border-0" : ""}`}
                                onClick={() => {
                                    dispatch(
                                        openDialog({ type: "order", data: row, mainData: row })
                                    );
                                }}
                            >
                                <IconEdit className="text-secondary" />
                            </button>
                        {/* )} */}
                    </div>
                );
            },
        },
    ];
    const showActionHeader = orderTable.some(
        (row) => row?.status !== "Cancelled"
    );
    if (!showActionHeader) {
        orderTable = orderTable.filter((column) => column.Header !== "Action");
    }
    return (
        <div className="userPage">
            <div className="user-table mb-3">
                <div className="user-table-top">
                    <div className=" d-flex justify-content-between align-items-center w-100 ">
                        <div className="w-100">
                            <h5 className="main-title">Orders</h5>
                        </div>
                        <div className="d-flex gap-2 justify-content-end w-100">
                            <div className="inputData">
                                <select
                                    name="bookingType"
                                    className="form-select"
                                    id="bookingType"
                                    value={type}
                                    onChange={(e) => {
                                        setType(e.target.value);
                                    }}
                                >
                                    <option value="All" selected>
                                        All
                                    </option>
                                    {orderType?.map((data) => {
                                        return <option value={data?.value}>{data?.name}</option>;
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    {/* {dialogue && dialogueType === "order" && (
                        <EditOrder statusData={sendStatus} />
                )} */}

                    <Table
                        data={flattenedOrders}
                        mapData={orderTable}
                        serverPerPage={rowsPerPage}
                        Page={page}
                    />
                    <Pagination
                        type={"server"}
                        serverPage={page}
                        setServerPage={setPage}
                        serverPerPage={rowsPerPage}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        totalData={total}
                    />
                </div>
            </div>

            {dialogue && dialogueType === "order" && (
                <EditOrder page={page} rowsPerPage={rowsPerPage} type={type} />
            )}
        </div>
    );
};
export default Order;
